'use client';

import { cx } from '@otter-ai/den-components';

export type ContentContainerProps = {
  children: React.ReactNode;
  className?: string;
  /**
   * The width of the content container.
   */
  width?: 'md' | 'lg' | 'full';
};

/**
 * Wrapper the content of the account settings page.
 */
export function ContentContainer({
  children,
  width = 'md',
  className,
}: ContentContainerProps) {
  const widthClassName =
    width === 'md'
      ? 'max-w-[944px]'
      : width === 'lg'
        ? 'max-w-[1151px]'
        : 'max-w-full';
  return (
    <div
      className={cx(
        'w-full px-2 py-4 sm:px-4 md:px-6 mx-auto',
        widthClassName,
        className,
      )}
    >
      {children}
    </div>
  );
}
